import { Navigate, Route, Routes } from 'react-router-dom';
import AMCreateCompany from 'src/components/accountManager/AMCreateCompany';
import AMEditCompany from 'src/components/accountManager/AMEditCompany';
import FresherCandidateListing from 'src/components/newRecruiterFlow/freshers/FresherCandidateListing';
import PositionCandidateListing from 'src/components/newRecruiterFlow/freshersPosition/PositionCandidateListing';
import CreateHiringAssessment from 'src/components/recruiterPositions/recruiterTypes/CreateHiringAssessment';
import HiringAssessmentCandidateListing from 'src/components/recruiterPositions/recruiterTypes/HiringAssessment/HiringAssessmentCandidateListing';
import ShareHiringAssessment from 'src/components/recruiterPositions/recruiterTypes/ShareHiringAssessment';
import CreatePositionRouter from 'src/pages/CreatePosition';
import Job from 'src/pages/Job';
import JobPreview from 'src/pages/JobPreview';
import LeadsGenPOCsPage from 'src/pages/LeadsGenPOCPage';
import RecruiterCandidatesPage from 'src/pages/RecruiterCandidatesPage';
import RecruiterDashboard from 'src/pages/RecruiterDashboard';
import AMBriefDebriefCalls from 'src/pages/accountManagers/AMBriefDebriefCalls';
import AMCompaniesPage from 'src/pages/accountManagers/AMCompaniesPage';
import AMPositionsPage from 'src/pages/accountManagers/AMPositionsPage';
import EditDrivePositionRouter from 'src/pages/editDrivePosition';
import EditPositionRouter from 'src/pages/editPosition';
import CampusCandidatesListingPage from 'src/pages/newRecruiterFlow/CampusCandidatesListingPage';
import DriveCandidatesListingPage from 'src/pages/newRecruiterFlow/DriveCandidatesListingPage';
import DriveCompaniesPage from 'src/pages/newRecruiterFlow/DriveCompaniesPage';
import DriveFormForRecruiter from 'src/pages/newRecruiterFlow/DriveFormForRecruiter';
import DrivePositionsPage from 'src/pages/newRecruiterFlow/DrivePositionsPage';
import HiringAssessmentCandidatePage from 'src/pages/newRecruiterFlow/HiringAssessmentCandidatePage';
import HiringAssessmentListPage from 'src/pages/newRecruiterFlow/HiringAssessmentListPage';
import NewRecruiterPositionsPage from 'src/pages/newRecruiterFlow/NewRecruiterPositionsPage';
import SelectHiringFlowPage from 'src/pages/newRecruiterFlow/SelectHiringFlowPage';
import UpcomingDriveListingPage from 'src/pages/newRecruiterFlow/UpcomingDriveListingPage';
import Profile from 'src/pages/profile/Profile';
import { RecruiterSupport } from 'src/pages/recruiter-support/RecruiterSupport';
import AMAssignedTickets from 'src/pages/accountManagers/AMAssignedTickets';
import AMTicketView from 'src/pages/accountManagers/AMTicketView';
import { UserExperienceLevelType } from 'types';

const AccountManagerRoutes = () => {
	return (
		<Routes>
			{/* 
			Start: New routes
			 */}

			{/* <Route path="/recruiter-dashboard" element={<RecruiterDashboard />} />
			<Route path="/recruiter-dashboard/hiring-assessment-list" element={<HiringAssessmentListPage />} />
			<Route path="/recruiter-dashboard/hiring-assessment-list/:id" element={<HiringAssessmentCandidateListing />} />
			<Route
				path="/recruiter-dashboard/hiring-assessment/:hiringAssessmentId/candidates"
				element={<HiringAssessmentCandidatePage />}
			/>
			<Route path="/select-hiring-type" element={<SelectHiringFlowPage />} />
			<Route path="/recruiter-dashboard/positions" element={<NewRecruiterPositionsPage />} />
			<Route path="/campus-candidates" element={<CampusCandidatesListingPage />} />
			<Route
				path="/fresher-candidates"
				element={<FresherCandidateListing experienceLevelBuckets={UserExperienceLevelType.FRESHER} />}
			/>
			<Route
				path="/experience-candidates"
				element={<FresherCandidateListing experienceLevelBuckets={UserExperienceLevelType.OneToTwoYears} />}
			/>
			<Route path="/view-candidates/position/:positionId" element={<PositionCandidateListing />} />
			<Route path="/benchmarking/create-hiring-assessment" element={<CreateHiringAssessment />} />
			<Route path="/benchmarking/share-hiring-assessment" element={<ShareHiringAssessment />} /> */}
			{/* 
			End: New routes
			 */}
			<Route path="/drive-form" element={<DriveFormForRecruiter />} />
			<Route path="/drive-companies" element={<DriveCompaniesPage />} />
			<Route path="/drive-positions/:id" element={<DrivePositionsPage />} />
			<Route path="/drive-positions/candidates/:company/:id" element={<DriveCandidatesListingPage />} />
			<Route path="/upcoming-drives" element={<UpcomingDriveListingPage />} />
			<Route path="/companies" element={<AMCompaniesPage />} />
			<Route path="/brief-debriefs" element={<AMBriefDebriefCalls />} />
			<Route path="/create-company" element={<AMCreateCompany />} />
			<Route path="/edit-company/:companyId" element={<AMEditCompany />} />
			<Route path="/my-positions/:companyId" element={<AMPositionsPage />} />
			<Route path="/create-position/:companyId" element={<CreatePositionRouter />} />
			<Route path="/job-preview/:companyId/:jobId" element={<JobPreview />} />
			<Route path="/pipeline/:companyId/:positionId" element={<RecruiterCandidatesPage />} />
			{/* <Route path="/explainers/:jobId" element={<Explainers />} /> */}
			<Route path="/support" element={<RecruiterSupport />} />
			<Route path="/tickets" element={<AMAssignedTickets />} />
			<Route path="/tickets/:id" element={<AMTicketView />} />
			<Route path="/edit-position/:companyId/:jobId" element={<EditPositionRouter />} />
			<Route path="/positions/:companyId/:positionId/candidates" element={<RecruiterCandidatesPage />} />
			<Route path="/job/:jobId" element={<Job />} />
			<Route path="/profile/:userHandler" element={<Profile />} />
			<Route path="/edit-drive-position/:companyId/:positionId" element={<EditDrivePositionRouter />} />

			<Route path="*" element={<Navigate to="/companies" />} />
			{/* <Route path="*" element={<Navigate to="/select-hiring-type" />} /> */}
		</Routes>
	);
};

export default AccountManagerRoutes;
